<template>
  <div class="countdown">
    <p :class="{'text-danger': total<=0}" />
      <strong>{{hours}}</strong>
      <strong>:</strong>
      <strong>{{minutes}}</strong>
      <strong>:</strong>
      <strong>{{seconds}}</strong>
    </p>
  </div>
</template>

<script>
export default {
  name: "Countdown",
  props: {
    time: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      total: "",
      hours: "--",
      minutes: "--",
      seconds: "--",
      interval: 0
    };
  },
  mounted() {
    this.total = parseInt(this.time, 10);
    this.interval = setInterval(() => {
      this.tick();
    }, 1000);
  },

  methods: {
    str_pad_left(string, pad, length) {
      return (new Array(length + 1).join(pad) + string).slice(-length);
    },
    tick() {
      let hours = Math.floor(this.total / 3600);
      let timeLeft = this.total - hours * 3600;
      let minutes = parseInt(timeLeft / 60);
      let seconds = timeLeft - minutes * 60;

      this.hours = this.str_pad_left(hours, "0", 2);
      this.minutes = this.str_pad_left(minutes, "0", 2);
      this.seconds = this.str_pad_left(seconds, "0", 2);
      if (this.total <= 0) {
        clearInterval(this.interval);
        this.$EventBus.$emit('finalCountdown', this.total)
      }
      this.total -= 1;
    },
  }
};
</script>

<style lang="scss" scoped>
.countdown {
  font-size: 24px;
  align-self: flex-end;
}
</style>